class StoreDeviceModelInput {
  constructor (
    id = undefined,
    name,
    externalEventId,
    modelId,
    inputNumber = null
  ) {
    this.id = id
    this.name = name
    this.externalEventId = externalEventId
    this.modelId = modelId
    this.inputNumber = inputNumber ?? null
    this.model = null
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name,
      externalEventId: this.externalEventId,
      inputNumber: this.inputNumber
      // modelId is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    externalEventId,
    modelId,
    inputNumber
  }) {
    return new StoreDeviceModelInput(
      id,
      name,
      externalEventId,
      modelId,
      inputNumber
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      externalEventId: this.externalEventId,
      modelId: this.modelId,
      inputNumber: this.inputNumber
    }
  }

  static FromJSON ({
    id,
    name,
    externalEventId,
    modelId,
    inputNumber
  }) {
    return new StoreDeviceModelInput(
      id,
      name,
      externalEventId,
      modelId,
      inputNumber
    )
  }
}

export default StoreDeviceModelInput
